require('./_wks-define')('asyncIterator');



// WEBPACK FOOTER //
// webpack:///node_modules/core-js/modules/es7.symbol.async-iterator.js